// removed by extract-text-webpack-plugin
module.exports = {"packages":"JxNQFPkHyFos3xSBY2GjF","viewSwitcher":"_2DIIEzckk5g_jt7VjOtQqS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RealtorPackagesContainer/RealtorPackagesContainer.scss
// module id = 1839
// module chunks = 0